import React from 'react'
import Snackbar from '@mui/material/Snackbar'
import MuiAlert from '@mui/material/Alert'
import { useNotification } from '@context/NotificationContext'

const Alert = React.forwardRef(function Alert (props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />
})

const Notification = () => {
  const { message, type, open, hideNotification } = useNotification()

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={hideNotification}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert onClose={hideNotification} severity={type}>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default Notification
